import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import FormPartial from './FormPartial.js';
import SecurityAmountDisplay from '../../models/SecurityAmountDisplay.js';
import { getApi } from '../../api/endpoints.js';

const New = (props) => {

  const navigate = useNavigate();
  const securityAmountDisplayObj = new SecurityAmountDisplay();
  const [securityAmountDisplay, setSecurityAmountDisplay] = useState(securityAmountDisplayObj.toStateJson());
  const [createApi] = getApi('createSecurityAmount')

  const createRecord = async (params) => {
    try {
      let response = await createApi(params).unwrap();
      navigate("/security_amounts");
    } catch(error) {
      securityAmountDisplayObj.set_api_errors(error.data.data.errors);
      setSecurityAmountDisplay(securityAmountDisplayObj.toStateJson())
    }
  }

  const handleSubmitFunction = () => {
    createRecord((new SecurityAmountDisplay(securityAmountDisplay)).toApiJson());
  }

  const handleCancelFunction = () => {
    navigate('/security_amounts');
  }

  return (
    <Page
      uiPage={uiManager.getUiPage(PAGES.NewSecurityAmountPage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "Security Amounts List", url: '/security_amounts' }, { label: "Generate New Security Amount" }]}
      className={'security-amount-page'}
    >
      <PageContentWrapper contentHeading={"Generate New Security Amount"}>
        <div className='m-3'>
          <div className='mb-4 col-md-12'>
            <form className="row g-3" autoComplete="off">
              <FormPartial securityAmountDisplay={securityAmountDisplay} setSecurityAmountDisplay={setSecurityAmountDisplay} />
              <div className='mb-4 col-md-12'>
                <div >
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Create Security Amount</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
  );
}

export default New;
